"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCreateLicenseObservationsDto = instanceOfCreateLicenseObservationsDto;
exports.CreateLicenseObservationsDtoFromJSON = CreateLicenseObservationsDtoFromJSON;
exports.CreateLicenseObservationsDtoFromJSONTyped = CreateLicenseObservationsDtoFromJSONTyped;
exports.CreateLicenseObservationsDtoToJSON = CreateLicenseObservationsDtoToJSON;
exports.CreateLicenseObservationsDtoToJSONTyped = CreateLicenseObservationsDtoToJSONTyped;
const LicenseObservationDto_1 = require("./LicenseObservationDto");
/**
 * Check if a given object implements the CreateLicenseObservationsDto interface.
 */
function instanceOfCreateLicenseObservationsDto(value) {
    if (!('licenses' in value) || value['licenses'] === undefined)
        return false;
    return true;
}
function CreateLicenseObservationsDtoFromJSON(json) {
    return CreateLicenseObservationsDtoFromJSONTyped(json, false);
}
function CreateLicenseObservationsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'licenses': (json['licenses'].map(LicenseObservationDto_1.LicenseObservationDtoFromJSON)),
    };
}
function CreateLicenseObservationsDtoToJSON(json) {
    return CreateLicenseObservationsDtoToJSONTyped(json, false);
}
function CreateLicenseObservationsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'licenses': (value['licenses'].map(LicenseObservationDto_1.LicenseObservationDtoToJSON)),
    };
}
//# sourceMappingURL=CreateLicenseObservationsDto.js.map